<template>
  <a-tag v-if="state === TicketState.wait">En cola</a-tag>
  <a-tag v-if="state === TicketState.delivered" class="assigned">Asignado</a-tag>
  <a-tag v-if="state === TicketState.finished" class="resolved">Resuelto</a-tag>
</template>

<script>
import { TicketState } from "@/app/shared/utils/enums";

export default {
  props: {
    state: {
      type: Number,
      required: true,
    },
  },
  setup() {
    return {
      TicketState,
    };
  },
};
</script>

<style lang="sass" scoped>
.assigned
  background-color: $green-1
  color: $green-6
  border-color: $green-3
  width: fit-content

.resolved
  background-color: $cyan-1
  color: $cyan-6
  border-color: $cyan-3
  width: fit-content
</style>
